// @ts-strict-ignore
import { useMutation } from '@tanstack/react-query'
import { postPaymentCaseEmail } from 'services/PaymentsService'
import { logSentryError } from 'utils/sentry'

export const useSendPaymentCaseEmailMutation = () => {
  return useMutation({
    mutationFn: postPaymentCaseEmail,
    onError: (error, data) => {
      logSentryError('Error: useSendPaymentCaseEmailMutation', error, data)
    },
  })
}
